import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";

/**
 * Opens a URL respecting the current platform context.
 *
 * - Native app: uses @capacitor/browser (SFSafariViewController on iOS / Chrome Custom Tab on Android),
 *   which bypasses window.open async restrictions and Universal Links interception.
 *
 * - Web browser: uses a programmatic anchor click with rel="noreferrer", which prevents
 *   iOS Universal Links from intercepting the navigation and opening a native app instead.
 *
 * @param {string} url
 */
export function openUrl(url) {
  if (Capacitor.isNativePlatform()) {
    return Browser.open({ url });
  }

  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noreferrer noopener";
  a.click();
}
